import React, { useState, useEffect } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

import ScanBadgeButton from '../../components/scan-badge-button/scan-badge-button';

import SenseModeImg from './qr_setup_codes/sense_mode.png';
import EnglishImg from './qr_setup_codes/english.png';
import OneHourSleepImg from './qr_setup_codes/one_hour_sleep.png';
import DataClearImg from './qr_setup_codes/data_clear.png';
import HighVolumeImg from './qr_setup_codes/high_volume.png';
import NormalModeImg from './qr_setup_codes/normal_mode.png';
import TestImg from './qr_setup_codes/test.png';

const Setup = ({ user }) => {
  const [isTestOpen, setIsTestOpen] = useState(false);
  const [isSetupOpen, setIsSetupOpen] = useState(true);
  const [scanResult, setScanResult] = useState(null);

  const successfulTestCode = 'ameya-jadhav';

  useEffect(() => {
    let timer;
    if (scanResult === successfulTestCode) {
      timer = setTimeout(() => {
        setScanResult(null);
      }, 3000);
    }
    return () => clearTimeout(timer);
  }, [scanResult]);

  const setupSteps = [
    {
      title: 'Enable automatic scanning',
      image: SenseModeImg,
      isBarcode: true,
    },
    {
      title: 'Set to English',
      image: EnglishImg,
    },
    {
      title: 'Set sleep timer (1 hour default)',
      image: OneHourSleepImg,
    },
    {
      title: 'Clear all scanned data',
      image: DataClearImg,
    },
    {
      title: 'Set high volume',
      image: HighVolumeImg,
    },
    {
      title: 'Set normal mode',
      image: NormalModeImg,
    },
  ];

  return (
    <div className='max-w-5xl mx-auto p-8 space-y-8'>
      {/* Test Scanner Section */}
      <div className='border rounded-lg shadow'>
        <button
          onClick={() => setIsTestOpen(!isTestOpen)}
          className='bg-gray-50 flex hover:bg-gray-100 items-center justify-between p-4 rounded-t-lg w-full'>
          <span className='font-medium text-lg'>Match Scanner</span>
          {isTestOpen ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
        </button>

        {isTestOpen && (
          <div className='p-8'>
            <div className='flex flex-col items-center'>
              <p className='max-w-2xl mb-8 text-center text-gray-700 text-lg'>
                Scan the QR code below and if you see "Matched Successfully!"
                message appear that means the scanner you are holding matches
                with the base that's plugged in. Make sure to scan the codes in
                the Scanner Setup Instructions section below.
              </p>

              <div className='h-48 mb-8 w-48'>
                <img
                  src={TestImg}
                  alt='Test QR Code'
                  className='h-full object-contain w-full'
                />
              </div>
              <ScanBadgeButton
                scannedReturnedID={scanResult}
                setScannedReturnedID={setScanResult}
                disabled={false}
              />

              {scanResult === successfulTestCode && (
                <div className='bg-green-100 border-2 border-green-500 max-w-md mt-8 p-6 rounded-lg text-center w-full'>
                  <span className='font-bold text-2xl text-green-700'>
                    Matched Successfully!
                  </span>
                </div>
              )}
            </div>
          </div>
        )}
      </div>

      {/* Setup Instructions */}
      <div className='border rounded-lg shadow'>
        <button
          onClick={() => setIsSetupOpen(!isSetupOpen)}
          className='bg-gray-50 flex hover:bg-gray-100 items-center justify-between p-4 rounded-t-lg w-full'>
          <span className='font-medium text-lg'>
            Scanner Setup Instructions
          </span>
          {isSetupOpen ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
        </button>

        {isSetupOpen && (
          <div className='p-8'>
            <h1 className='font-bold mb-12 text-2xl text-center'>
              Scan ALL of these QR codes to set up the scanner...
            </h1>

            <div className='gap-16 grid lg:grid-cols-2 md:grid-cols-2'>
              {setupSteps.map((step, index) => (
                <div
                  key={index}
                  className='flex flex-col items-center mb-8'>
                  <p className='font-medium mb-6 text-center text-gray-700 text-lg'>
                    {step.title}
                  </p>
                  <div className={step.isBarcode ? 'w-96 h-32' : 'w-48 h-48'}>
                    <img
                      src={step.image}
                      alt={`${step.isBarcode ? 'Barcode' : 'QR Code'} for ${
                        step.title
                      }`}
                      className='h-full object-contain w-full'
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Setup;
